module.exports = __webpack_public_path__ + "img/people-22.598a2b00.png";